var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7288 3.25C7.17241 3.25 3.47876 6.94365 3.47876 11.5C3.47876 16.0563 7.17241 19.75 11.7288 19.75C16.2851 19.75 19.9788 16.0563 19.9788 11.5C19.9788 6.94365 16.2851 3.25 11.7288 3.25ZM1.97876 11.5C1.97876 6.11522 6.34398 1.75 11.7288 1.75C17.1135 1.75 21.4788 6.11522 21.4788 11.5C21.4788 16.8848 17.1135 21.25 11.7288 21.25C6.34398 21.25 1.97876 16.8848 1.97876 11.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2161 17.4555C17.5086 17.1622 17.9834 17.1616 18.2767 17.4541L21.8007 20.969C22.094 21.2615 22.0946 21.7363 21.8021 22.0296C21.5096 22.3229 21.0347 22.3235 20.7415 22.031L17.2174 18.5161C16.9242 18.2236 16.9235 17.7487 17.2161 17.4555Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7263f50ef69363c9b7266598c2ab9111.svg";
export { ForwardRef as ReactComponent };